import createStorageSyncPlugin from "@/plugins/vuex-storage-sync";
import loadingStore from "@/store/modules/loading";
import studentStore from "@/store/modules/student";
import teacherStore from "@/store/modules/teacher";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// Create the storage sync plugin
const storageSyncPlugin = createStorageSyncPlugin({
  states: [
    "student.currentScenario",
    "student.currentTopicId",
    "student.scenarioState",
    "teacher.currentClass",
    "teacher.classTournamentState",
    "teacher.offlineMode",
    "teacher.currentLecture",
    "teacher.teacherProfile",
  ],
});

export default new Vuex.Store({
  modules: {
    loading: loadingStore,
    student: studentStore,
    teacher: teacherStore,
  },
  plugins: [storageSyncPlugin],
  getters: {
    // Centralized user identification getters
    isAdmin(state) {
      // Check if student profile has admin flag
      const studentIsAdmin = state.student.profile?.isAdmin ?? false;
      // Check if teacher profile has admin flag
      const teacherIsAdmin = state.teacher.teacherProfile?.isAdmin ?? false;
      return studentIsAdmin || teacherIsAdmin;
    },

    isTeacher(state) {
      return state.teacher.teacherProfile?.firstName ? true : false;
    },

    isStudent(state) {
      return state.student.profile?.user_id ? true : false;
    },

    // Returns the current user ID (teacherId for teachers, user_id for students)
    getCurrentUserId(state, getters) {
      if (getters.isTeacher) {
        return state.teacher.teacherProfile?.teacherId;
      }
      if (getters.isStudent) {
        return `${state.student.profile.user_id}`;
      }
      return null;
    },
  },
});
